import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import {BrowserRouter} from 'react-router-dom';
import ErrorHandler  from './ErrorHandler'

import { Provider } from 'react-redux'

import { createAppStore } from './store'
const appStore = createAppStore()

ReactDOM.render(
  <React.StrictMode>
    <Provider store={appStore}>
      <ErrorHandler><BrowserRouter><App /></BrowserRouter></ErrorHandler>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
